import { render, staticRenderFns } from "./HappilyIcon.vue?vue&type=template&id=4da63cfd&scoped=true&"
import script from "./HappilyIcon.vue?vue&type=script&lang=js&"
export * from "./HappilyIcon.vue?vue&type=script&lang=js&"
import style0 from "./HappilyIcon.vue?vue&type=style&index=0&id=4da63cfd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da63cfd",
  null
  
)

export default component.exports